"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var PartnerSettings_module_css_1 = __importDefault(require("./PartnerSettings.module.css"));
var PartnerUniverse = function () {
    return (react_1.default.createElement("div", { className: PartnerSettings_module_css_1.default.iframeContainer },
        react_1.default.createElement("iframe", { src: "https://nordicscreen.com/partners/", width: "100%", height: "100%", allow: "autoplay" })));
};
exports.default = PartnerUniverse;
